<template>
	<div class="logo">
		<a href="/">
			<img src="@/assets/img/logo.png" alt="Ius Populi" class="img-responsive" />
		</a>
	</div>
</template>

<script>
export default {
	name: 'HeaderLogo',
}
</script>



// WEBPACK FOOTER //
// src/components/header/HeaderLogo.vue